<template>
  <section>
    <div style="display: flex; flex-direction: column; background: #f8f9fc;">
      <div
        style="display: flex; margin: 0 16px; background"
        :style="{ justifyContent: isMobile ? 'left' : 'center' }"
      >
        <img src="@/assets/icons/ic-system-viabus.svg" style="margin-top: 20px;" />
      </div>
      <div
        style="position: absolute; display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;"
      >
        <div v-if="verifying" class="verifying">
          <div class="loading loader loader-denim">
            Loading...
          </div>
        </div>
        <div
          v-else-if="error"
          style="display: flex; flex-direction: column; align-items: center; margin-bottom: 12vh;"
        >
          <img src="@/assets/icons/icon-32-ic-warning-oval.svg" />
          <div class="title">{{ getI18nMessage('cannotConnect') }}</div>
          <div style="margin-top: 5vh" class="filled-xl-button" @click="retryVerifying">
            {{ getI18nMessage('tryAgain') }}
          </div>
        </div>
        <div
          v-else-if="verified"
          style="display: flex; flex-direction: column; align-items: center; margin-bottom: 12vh;"
        >
          <img src="@/assets/icons/icon-32-ic-done-oval.svg" />
          <div class="title">{{ getI18nMessage('verified') }}</div>
          <div
            style="margin-top: 5vh;
              display: flex;
              flex-direction: column;
              align-items: center;
              align-content: center;
              justify-content: flex-start;"
          >
            <div
              v-if="setPasswordActivationCode != null"
              class="filled-xl-button"
              style="margin-bottom: 16px"
              @click="openChangePassword"
            >
              {{ getI18nMessage('openChangePassword') }}
            </div>
            <div
              v-if="isMobile"
              :class="setPasswordActivationCode != null ? 'bordered-xl-button' : 'filled-xl-button'"
              @click="openViaBusApp"
            >
              {{ getI18nMessage('openViaBusApp') }}
            </div>
            <div v-else class="open-app-hint">{{ getI18nMessage('openViaBusApp') }}</div>
          </div>
        </div>
      </div>
      <Footer :language="language"> </Footer>
    </div>
  </section>
</template>

<script>
import { get } from 'lodash';
import { verifyEmailByKey } from '@/services/userService';
import { isMobile } from '@/utils/useragent';

import Footer from '@/components/footer';

const i18n = {
  mobile: {
    verified: {
      th: 'ยืนยันสมาชิก\nของคุณเรียบร้อย!',
      en: 'You’re Now Verified!',
    },
    openViaBusApp: {
      th: 'เปิดแอป ViaBus',
      en: 'Open ViaBus App',
    },
    openChangePassword: {
      th: 'ตั้งรหัสผ่าน',
      en: 'Set Password',
    },
    cannotConnect: {
      th: 'มีบางอย่างขัดข้อง',
      en: 'Something Went Wrong',
    },
    tryAgain: {
      th: 'ลองอีกครั้ง',
      en: 'Try again',
    },
  },
  desktop: {
    verified: {
      th: 'ยืนยันสมาชิกของคุณเรียบร้อย!',
      en: 'You’re Now Verified!',
    },
    openViaBusApp: {
      th: 'เปิด ViaBus บนโทรศัพท์ของคุณเพื่อเริ่มใช้งานทันที!',
      en: 'Open the ViaBus app on your phone to start now!',
    },
    openChangePassword: {
      th: 'ตั้งรหัสผ่าน',
      en: 'Set Password',
    },
    cannotConnect: {
      th: 'มีบางอย่างขัดข้อง',
      en: 'Something Went Wrong',
    },
    tryAgain: {
      th: 'ลองอีกครั้ง',
      en: 'Try again',
    },
  },
};

export default {
  components: { Footer },
  computed: {
    isMobile,
  },
  data() {
    return {
      language: 'en',
      key: '',
      verifying: true,
      verified: false,
      setPasswordActivationCode: null,
      error: false,
    };
  },
  watch: {},
  methods: {
    getI18nMessage(key) {
      return get(i18n, `${this.isMobile ? 'mobile' : 'desktop'}.${key}.${this.language}`, '');
    },
    verify(key) {
      this.error = false;
      this.verifying = true;
      verifyEmailByKey(key)
        .then(response => {
          const decodedKey = atob(key);
          const encodedEmail = decodedKey.split(':')[0];
          this.setPasswordActivationCode = response.data.detail.activation_code
            ? btoa(`${encodedEmail}:${btoa(response.data.detail.activation_code)}`)
            : null;
          this.verified = true;
        })
        .catch(err => {
          let statusCode = get(err, 'response.data.stat');
          if (statusCode == 400) {
            // Expires or Invalid key
            this.$router.push({ name: 'LinkExpired', query: this.$route.query });
          } else if (statusCode == 462) {
            // Already verified
            this.verified = true;
          } else {
            this.error = true;
          }
        })
        .finally(() => {
          this.verifying = false;
        });
    },
    openViaBusApp() {
      location.href = 'co.viabus://link?action=open';
    },
    openChangePassword() {
      this.$router.push({
        name: 'ChangePassword',
        query: { key: this.setPasswordActivationCode },
      });
    },
    retryVerifying() {
      this.verify(this.key);
    },
  },
  mounted() {
    let lang = get(this.$route.query, 'lang', 'th').trim();
    if (lang === 'en' || lang === 'th') {
      this.language = lang;
    }

    this.key = get(this.$route.query, 'key', '').trim();

    if (this.key) {
      this.verify(this.key);
    } else {
      this.$router.push({ name: 'LinkInvalid', query: this.$route.query });
    }
  },
};
</script>

<style scoped>
@import '../css/spinner.css';

.title {
  font-size: 24px;
  font-weight: bold;
  color: #263373;
  text-align: center;
  margin-top: 24px;
  white-space: pre;
}

.open-app-hint {
  margin-top: 5vh;
  font-size: 17px;
  font-weight: 500;
  color: #263373;
}

.loading {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
</style>

<style lang="less" scoped>
.verifying {
  width: 15vw;
  height: calc(100vw * 0.15);
  margin-bottom: 12vh;
}
</style>
